import axios from "axios";

const BaseUrl = process.env.REACT_APP_BASH_URL;

/**
 * Send reset OTP to vendor email
 * POST /v1/vendor/send-reset-otp
 * Body: { email: string }
 */
export const sendResetOtp = async (email) => {
  const response = await axios.post(
    `${BaseUrl}/vendor/send-reset-otp`,
    { email },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

/**
 * Reset password with OTP
 * POST /v1/vendor/reset-password-with-otp
 * Body: { email: string, otp: string, newPassword: string }
 */
export const resetPasswordWithOtp = async (email, otp, newPassword) => {
  const response = await axios.post(
    `${BaseUrl}/vendor/reset-password-with-otp`,
    { email, otp, newPassword },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};
